import { create } from 'zustand';
import { devtools, persist } from 'zustand/middleware';
import languageKo from '../data/language/ko.json';
import languageEn from '../data/language/en.json';

interface LanguageStoreState {
  language: string;
  languagePack: any;
  setLanguage: (language: string) => void;
}

export const useLanguageStore = create<LanguageStoreState>()(
  persist(
    devtools((set) => ({
      language: 'ko',
      languagePack: languageKo,
      setLanguage: (language: string) => {
        const newLanguagePack = language === 'ko' ? languageKo : languageEn;
        set({ language, languagePack: newLanguagePack });
      },
    })),
    {
      name: 'language-storage',
    }
  )
);
